import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-search\"><path d=\"M16.012 7.945c4.46 0 8.039 3.714 8.039 8.25a8.363 8.363 0 0 1-1.573 4.9l1.783 1.835a.75.75 0 0 1-1.076 1.045l-1.696-1.745a7.891 7.891 0 0 1-5.477 2.215c-4.46 0-8.04-3.714-8.04-8.25s3.58-8.25 8.04-8.25Zm0 1.5c-3.592 0-6.54 3.002-6.54 6.75s2.948 6.75 6.54 6.75c3.591 0 6.539-3.002 6.539-6.75s-2.948-6.75-6.54-6.75Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol